import { render, staticRenderFns } from "./PurposeInput.vue?vue&type=template&id=c28b3f8a&scoped=true"
import script from "./PurposeInput.vue?vue&type=script&lang=js"
export * from "./PurposeInput.vue?vue&type=script&lang=js"
import style0 from "./PurposeInput.vue?vue&type=style&index=0&id=c28b3f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b3f8a",
  null
  
)

export default component.exports